import {Component, OnInit, Renderer2} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute, Router} from '@angular/router';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {ClinicalSccaiResults, Q_CLINICAL_SCCAI} from '../../../../model/questionnaires/questionnaire-clinical-sccai';

@Component({
  selector: 'app-questionnaire-clinical-sccai',
  templateUrl: './questionnaire-clinical-sccai.component.html',
  styleUrls: ['./questionnaire-clinical-sccai.component.css']
})
export class QuestionnaireClinicalSCCAIComponent implements OnInit {

  qForm: FormGroup;
  dataSource = Q_CLINICAL_SCCAI;
  notFocused = false;
  submitted = false;
  show = false;
  displayedColumns = ['position', 'question', 'value'];
  results = [];
  q = 'question';
  found = false;
  finalScore = 0;

  /// toolbar
  back = true;
  destination = '/landing';
  title = 'CLINICAL-SCCAI';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;
  currentCheckedValue = [null];

  constructor(private questionnaireService: QuestionnaireService,
              public dialog: MatDialog,
              private ren: Renderer2,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.dataSource.length; ++i) {
      this.results.push(null);
    }

    this.qForm = new FormGroup({});

    this.user = JSON.parse(localStorage.getItem('user'));
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = doctorID.localeCompare(params.doctorID) === 0;
      this.destination = '/patient-questionnaire-panel/' + this.patientSSN;
      if (params.back.localeCompare('global') === 0) {
        this.destination += '/global';
      } else {
        this.destination += '/local';
      }
      sessionStorage.setItem('destination', JSON.stringify(this.destination));
    });
  }

  onSubmit(value: any) {
    this.submitted = true;
    this.show = true;
    this.found = false;

    if (this.results.length !== this.dataSource.length) {
      this.show = false;
      this.submitted = false;
      this.found = true;
      const msg = 'Non hai finito di completare il questionario!';
      this.openErrorDialog(msg);
    } else {
      for (const r of this.results) {
        if (r === null) {
          this.show = false;
          this.submitted = false;
          this.found = true;
          const msg = 'Non hai finito di completare il questionario!';
          this.openErrorDialog(msg);
          break;
        }
      }

      if (!this.found) {
        console.log(this.finalScore);
        const resultToSend = new ClinicalSccaiResults(this.doctorID, this.patientSSN, this.results, this.finalScore);
        this.questionnaireService.sendForm(resultToSend, 'clinical-sccai', this.uuid);
      }
    }
  }

  setAnswer(answer: string, position: number, answers: string[]) {
    console.log(answer, position, answers);
    if (position >= 6) {
      if (this.results[position - 1] !== null) {
        console.log('Precedente: ', this.results[position - 1]);
        console.log('Final Score Before: ', this.finalScore);
        if (this.results[position - 1].localeCompare('Si') === 0) {
          this.finalScore -= 1;
        }
        console.log('Final Score After: ', this.finalScore);
      }
      if (answer.localeCompare('Si') === 0) {
        this.finalScore += 1;
      }
    } else {
      if (this.results[position - 1] !== null) {
        let dec = 0;
        answers.forEach(a => {
          if (a === this.results[position - 1]) {
            console.log('Final Score Before != 7: ', this.finalScore);
            this.finalScore -= dec;
            console.log('Final Score After: != 7', this.finalScore);
          }
          dec++;
        });
      }
      let inc = 0;
      answers.forEach(a => {
        if (a === answer) {
          this.finalScore += inc;
        }
        inc++;
      });
    }

    this.results[position - 1] = answer;

    console.log('Risposta: ', answer);
    console.log('Risultati: ', this.results);
    console.log('Final Score: ', this.finalScore);
    console.log(this.results);
  }

  checkState(el, position: number, answers: string[]) {
    setTimeout(() => {
      if (this.currentCheckedValue[position - 1] && this.currentCheckedValue[position - 1] === el.value) {
        el.checked = false;
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-focused');
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-program-focused');
        if (this.results[position - 1] !== null) {
          if (position >= 6) {
            if (this.results[position - 1] !== null) {
              console.log('Precedente: ', this.results[position - 1]);
              console.log('Final Score Before: ', this.finalScore);
              if (this.results[position - 1].localeCompare('Si') === 0) {
                this.finalScore -= 1;
              }
              console.log('Final Score After: ', this.finalScore);
            }
          } else {
            let dec = 0;
            answers.forEach(a => {
              if (a === this.results[position - 1]) {
                console.log('Final Score Before != 7: ', this.finalScore);
                this.finalScore -= dec;
                console.log('Final Score After: != 7', this.finalScore);
              }
              dec++;
            });
          }
        }
        this.currentCheckedValue[position - 1] = null;
        this.results[position - 1] = null;
      } else {
        this.currentCheckedValue[position - 1] = el.value;
      }
    });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }

}
